import { ApiMap } from '../ApiMap';
import { createApiCache } from './createApiCache';
const FormCache = {};
export function getFetchFormInfo(http) {
  const withFormCache = createApiCache(http.get, ApiMap.FORMS.getUrl, FormCache);
  return function fetchFormInfo(guid) {
    return withFormCache(guid);
  };
}
function fetchForms(query, http, fetchFormsCache) {
  if (query.name__contains && fetchFormsCache[query.name__contains]) {
    return Promise.resolve(fetchFormsCache[query.name__contains]);
  }
  return http.get(ApiMap.FORMS_LIST.getUrl(), {
    query
  }).then(forms => {
    if (query.name__contains) {
      fetchFormsCache[query.name__contains] = forms;
    }
    return forms;
  });
}
export function getFetchForms(http) {
  const fetchFormsCache = {};
  return query => fetchForms(query, http, fetchFormsCache);
}